export class ProjectsPageRequest {

  clientId: string;
  pageNum: number;
  pageSize: number;
  searchValue: string;
  sortBy: string;
  sortDir: string;

}
